"use client";
import type { Metadata, Viewport } from "next";
import "./globals.css"; 
import '../styles/variables.css';
import '../styles/components.css';
import { barlow, barlowCondensed, barlowSemiCondensed } from '@/lib/fonts';
import { IBM_Plex_Mono } from 'next/font/google';
import ClientProviders from "@/components/ClientProviders";
import TopBar from "@/components/TopBar";
import BackgroundWrapper from '@/components/BackgroundWrapper';
import { ThemeProvider } from "@/components/ThemeProvider";
import { SessionProvider } from "next-auth/react";
import { motion, AnimatePresence } from 'framer-motion';
import { usePathname } from "next/navigation";
import { RouteChangeProvider } from "@/providers/RouteChangeProvider";
import { Inter } from 'next/font/google';

const ibmPlexMono = IBM_Plex_Mono({
  subsets: ['latin'],
  weight: ['400', '500', '600'],
  variable: '--font-ibm-plex-mono',
});

const inter = Inter({ 
  subsets: ['latin'],
  display: 'swap',
});

interface RootLayoutProps {
  children: React.ReactNode;
}

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en" className={barlow.className}>
      <body className={`bg-black text-white antialiased ${ibmPlexMono.variable}`}>
        <ClientProviders>
          <BackgroundWrapper>
            <TopBar />
            {children}
          </BackgroundWrapper>
        </ClientProviders>
      </body>
    </html>
  );
}
